/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { log } from 'utils/logger';
import {
    RECEIVE_ERRORS,
    RECEIVE_CONTENTS_DATA,
    TRIGGER_FETCH,
    STORE_DATA,
    RECEIVE_QUESTIONNAIRE_DATA,
    CLEAR_CONTENTS_DATA
} from 'redux/actions/content_data'

/* ========== ~~~~~~~~~~ CONTENT DATA : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const contentData = (state = {}, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case TRIGGER_FETCH:
            action.contentIds.forEach(contentId => {
                let newContent = Object.assign({}, newState[contentId], { shouldFetch: true });
                newState = Object.assign({}, newState, { [contentId]: newContent });
            });
            return newState;
        case RECEIVE_CONTENTS_DATA:
            let collectionContentId = null;
            // find which content is a collection and set collectionContentId to it's id
            for (let contentId of Object.keys(newState)) {
                if (newState[contentId]['isCollection']) { collectionContentId = contentId;}
            }
            newState[collectionContentId]['ready'] = true;
            if (action.data.length === 0) { return newState; }
            for (let cdata of action.data) {
                newState[collectionContentId]['data'].push(_formatContentData(cdata))
            }
            log("GOT SOME DATA", action.data);
            return newState;
        case RECEIVE_QUESTIONNAIRE_DATA:
            newState[action.contentId]['ready'] = true;
            if (action.data.length === 0) { return newState; }
            newState[action.contentId]['questionnaires'] = {};
            let firstQuestionnaireFrame = 0;
            for (let questionnaire of action.data) {
                newState[action.contentId]['questionnaires'][firstQuestionnaireFrame] = {
                    category: questionnaire.category,
                    title: questionnaire.title,
                    description: questionnaire.description,
                    numOfQuestions: questionnaire.questions.length,
                    backgroundImageURL: questionnaire.backgroundImageURL,
                    backgroundColor: null,
                    id: questionnaire.id,
                    type: questionnaire.type,
                };
                firstQuestionnaireFrame += questionnaire.questions.length;
                for (let qdata of questionnaire.questions) {
                    newState[action.contentId]['data'].push(_formatQuestionnaireData(qdata))
                }
            }
            return newState;
        case CLEAR_CONTENTS_DATA:
            for (let contentId of action.contentIds) {
                const newContent = Object.assign({}, newState[contentId], {
                    data: [],
                    ready: false,
                    questionnaires: null,
                    storage: {}
                });
                newState = Object.assign({}, newState, { [contentId]: newContent});
            }
            return newState;
        case RECEIVE_ERRORS:
            log('GOT SOME ERROR', action.errors);
            return state;
        case STORE_DATA:
            newState = JSON.parse(JSON.stringify(state));
            newState[action.contentId]['storage'][action.propertyName] = action.data;
            return newState;
        default:
            return state;
    }
};

const _formatContentData = contentData =>{
    const specificContentProps = formatSpecificContentProps(contentData);
 return ({
    id: contentData.id,
    type: contentData.type,
    background: contentData.contentProperties.background,
    backgroundColor: contentData.contentProperties.backgroundColor,
     ...specificContentProps
        });
};

const formatSpecificContentProps = (contentData) => {
    switch (contentData.type) {
        case 'story':
            return ({
                story:{
                    contentSignature: contentData.contentSignature,
                    id: contentData.id,
                    type: contentData.type,
                    text: contentData.contentProperties.text,
                    ctaText: contentData.contentProperties.ctaText,
                    storyUrl: contentData.contentProperties.url,
                    image: null
                }
            });
        case 'quiz':
        case 'poll':
        default:
            return ({
                questionSignature: contentData.contentSignature,
                answerSignature: contentData.contentProperties.answerSignature,
                answers: _formatAnswersData(contentData.contentProperties.answers, contentData.contentProperties.answerSignature),
                question: {
                    id: contentData.id,
                    type: contentData.contentProperties.answersType,
                    text: contentData.contentProperties.text,
                    image: null
                }
            });
    }
};

const _formatAnswersData = (answersData, answerSignature) => {
    const answers = [];
    for (let answer of answersData) {
        answers.push({
            answerSignature,
            id: answer.id,
            text: answer.text,
            image: answer.image,
            emoji: answer.emoji,
            numOfTimesChosen: answer.numOfTimesChosen
        })
    }
    return answers;
};

const _formatQuestionnaireData = qdata => ({
    id: qdata.id,
    type: qdata.type,
    placeholder: qdata.answersType === 'input' ? qdata.placeholder : null,
    background: qdata.background,
    backgroundColor: qdata.backgroundColor,
    answerSignature: qdata.answerSignature,
    questionSignature: qdata.questionSignature,
    question: {
        id: qdata.id,
        type: qdata.answersType,
        text: qdata.text,
        image: null,
        validation: qdata.answersType === 'input' && qdata.validation !== undefined ? qdata.validation : null
    },
    answers: _formatQuestionnaireAnswersData(qdata.answers, qdata.answerSignature)
});

const _formatQuestionnaireAnswersData = (answersData, answerSignature) => {
    const answers = [];
    for (let answer of answersData) {
        answers.push({
            answerSignature,
            id: answer.id,
            text: answer.text,
            image: answer.image,
            emoji: answer.emoji,
        })
    }
    return answers;
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default contentData;
